<template>
    <div role="tabcard" class="tab-pane" id="new-change-order">
        <div class="card card-default">
            <div class="card-header">
                <div class="d-inline-block card-header-content">
                    <div class="title">{{ title }}</div>
                    <div v-if="isDraft">Draft change orders are not visible to customers until they are released.</div>
                </div>
                <div class="d-inline-block float-right">
                </div>
            </div>
            <div class="card-body">
                <change-order-form :project="project" :changeorders="changeorders" v-bind:is-editing="false" :isDraft="isDraft"></change-order-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'project', 'changeorders', 'isDraft'],
        
        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            title: function() {
                if (this.isDraft) return 'New draft change order';
                return 'New change order';
            }
        },

        watch: {
        },

        methods: {
        }
    }
</script>
